import React, {useEffect, useState} from 'react';
import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom";
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useAdminBucket} from "../../../components/utils";
import {useControlledTabs} from "../../../components/Tabs";
import {Icon, Title} from "../../../components/components";
import FormButton from "../../../components/forms/FormButton";
import ExtractForm from "../../../components/data_products/extracts/ExtractForm";
import { useGetDataVendorExtractAggregationOptionsQuery, useGetDataVendorExtractQuery, useRunDataVendorExtractMutation } from '../../../api/dataVendorExtractApiSlice';
import {useGetDataVendorAudiencesQuery} from "../../../api/dataVendorAudienceApiSlice";
import useRunExtract from '../../../components/data_products/useRunExtract';

export default function DataVendorExtract(props) {
  const { t } = useTranslation();
  const history = useHistory();
  const { dataVendorKey, extractId } = useParams();
  const { data: extract, isSuccess } = useGetDataVendorExtractQuery([dataVendorKey, extractId])
  const [run] = useRunDataVendorExtractMutation()
  const [tabProps, setActiveTab] = useControlledTabs("extract", props)
  const bucket = useAdminBucket(dataVendorKey)
  const { data: aggregationOptions = [] } = useGetDataVendorExtractAggregationOptionsQuery(dataVendorKey)
  const { data: audiences = [] } = useGetDataVendorAudiencesQuery(dataVendorKey)
  const handleBack = () => history.push({
    pathname: `/data_vendors/${dataVendorKey}`,
    state: {activeTab: tabProps.active}
  });
  const {extractRuning, runExtract} = useRunExtract( { extractId, extract, onStart: ()=>(run([dataVendorKey, extractId])), onStarted: ()=>(setActiveTab("extract_monitor")) })

  if( ! isSuccess ) { return (<></>) }
  return (
    <>
      <Title main={t("menu.extracts")} sub={extract.name} onBack={handleBack} group={false}>
        <FormButton edit state={{activeTab: tabProps.active}}/>
        <Button key="run" onClick={runExtract} disabled={extractRuning}>
          <Icon icon={extractRuning ? 'loading' : 'play'} text={t("extract.run")} />
        </Button>
      </Title>
      <ExtractForm
        disabled
        extract={extract}
        aggregationOptions={aggregationOptions}
        audiences={audiences}
        bucket={bucket}
        tabProps={tabProps}/>
    </>
  )
}
